import { List, ListItem } from "@mui/material";
import { IRoutePartProps } from "./RouteDescription";
import dangerIconResource from "../../assets/danger.svg"
import { JernbanekryssningMedSaerskiltFare } from "../../services/RuteplanAPI/models/JernbanekryssningMedSaerskiltFare";


export default function JernbanekryssningMedFare(props: IRoutePartProps) {
    
    return (
        <>
            {props.roadFeatures && props.roadFeatures.jernbanekryssingerMedSaerskiltFare && props.roadFeatures.jernbanekryssingerMedSaerskiltFare.length > 0 &&
            <List>
                {props.roadFeatures.jernbanekryssingerMedSaerskiltFare.map( (jernbanekryssingerMedSaerskiltFare: JernbanekryssningMedSaerskiltFare, index: number) => (  
                    <ListItem 
                        key={jernbanekryssingerMedSaerskiltFare.nvdbId + index} 
                        className="roadFeature" 
                        onClick={(event) => {props.onClick(jernbanekryssingerMedSaerskiltFare, event)}}
                        onMouseEnter={() => {props.onMouseEnterItem(jernbanekryssingerMedSaerskiltFare)}}
                        onMouseLeave={props.onMouseLeaveItem}>
                        <img src={dangerIconResource} height="24" alt="Jernbanekryssning med fare icon" style={{paddingRight:"5px"}}/>
                        Farlig jernbanekryssning: {jernbanekryssingerMedSaerskiltFare.nvdbId}
                    </ListItem>
                ))}
            </List>
            }
        </>
    )
}